import { registerCorvidEvent, composeSDKFactories, createElementPropsSDKFactory, toJSONBase, withValidation, clickPropsSDKFactory, changePropsSDKFactory, focusPropsSDKFactory, disablePropsSDKFactory, createAccessibilityPropSDKFactory, } from '@wix/editor-elements-corvid-utils';
import { toCssVarNameForamt } from '@wix/editor-elements-common-utils';
import { PersistTypes } from '@wix/editor-elements-types/leanComponents';
import { SdkMixin } from '../../buildtime';
const defaultSdkFactoryGenerators = {
    [SdkMixin.clickable]: () => clickPropsSDKFactory,
    [SdkMixin.changeable]: () => changePropsSDKFactory,
    [SdkMixin.focusable]: () => focusPropsSDKFactory,
    [SdkMixin.disableable]: () => disablePropsSDKFactory,
    [SdkMixin.element]: createElementPropsSDKFactory,
    [SdkMixin.accessible]: () => createAccessibilityPropSDKFactory(),
};
const mapMixinSDKFactories = (mixins, sdkMap) => (mixins ? mixins.map(mixin => sdkMap[mixin]()) : []);
export const createLeanComponentSDKFactory = ({ sdkMap, defaultMixins, }) => {
    return ({ sdkSchema, validationSchema, mixins, }) => {
        const defaultSDKFactories = defaultMixins.map(defaultMixin => sdkMap[defaultMixin]());
        const keys = Object.keys(sdkSchema);
        if (keys.length === 0) {
            return composeSDKFactories([
                ...defaultSDKFactories,
                ...mapMixinSDKFactories(mixins, sdkMap),
            ]);
        }
        const isFunction = (key) => sdkSchema[key].type === 'function';
        const functionKeys = keys.filter(key => isFunction(key));
        const serializableKeys = keys.filter(key => !isFunction(key));
        const sdkFactory = api => {
            const { props, metaData, setProps, setStyles, createSdkState } = api;
            const [state, setState] = createSdkState({});
            function addCorvidHandler(key) {
                sdk[key] = (handler) => registerCorvidEvent(key, api, handler);
            }
            function addSetterAndGetter(key) {
                Object.defineProperty(sdk, key, {
                    enumerable: true,
                    get: () => {
                        if (sdkSchema[key].persistence === PersistTypes.cssVariable) {
                            return state[key];
                        }
                        return props[key];
                    },
                    set: sdkSchema[key].readonly
                        ? undefined
                        : data => {
                            if (sdkSchema[key].persistence === PersistTypes.cssVariable) {
                                setStyles({
                                    [toCssVarNameForamt(key)]: `${data} !important`,
                                });
                                setState({ [key]: data });
                            }
                            else {
                                setProps({ [key]: data });
                            }
                        },
                });
            }
            const sdk = {
                toJSON() {
                    const pairs = Object.fromEntries(serializableKeys.map(key => [key, props[key]]));
                    return {
                        ...toJSONBase(metaData),
                        ...pairs,
                    };
                },
            };
            functionKeys.forEach(key => addCorvidHandler(key));
            serializableKeys.forEach(key => addSetterAndGetter(key));
            return sdk;
        };
        const sdks = [
            ...defaultSDKFactories,
            validationSchema
                ? withValidation(sdkFactory, validationSchema) // TODO here we could pass additional useful validation functions, like isWixUrl
                : sdkFactory,
            ...mapMixinSDKFactories(mixins, sdkMap),
        ];
        return composeSDKFactories(sdks);
    };
};
export const createLeanComponentSDK = createLeanComponentSDKFactory({
    sdkMap: defaultSdkFactoryGenerators,
    defaultMixins: [SdkMixin.element],
});
//# sourceMappingURL=createLeanComponentSDK.js.map